import { Map } from 'immutable';
import is from 'is_js';

import {
  TOGGLE_NAVIGATION,
  SHOW_NAVIGATION_BAR,
  TOGGLE_VIEW_MODE,
  VIEW_MODE,
  SET_CIC_DISPLAY_LANGUAGE,
  CIC_DISPLAY_LANGUAGE,
} from './actions';


export default function uiState(state = new Map({
  [SHOW_NAVIGATION_BAR]: getShowNavigationBarFromLocalStorage(),
  [VIEW_MODE]: undefined,
  [CIC_DISPLAY_LANGUAGE]: null,
}), action) {
  switch (action.type) {
    case TOGGLE_NAVIGATION:
      saveShowNavigationBarToLocalStorage(! state.get(SHOW_NAVIGATION_BAR));
      return state.set(SHOW_NAVIGATION_BAR, ! state.get(SHOW_NAVIGATION_BAR));
    case TOGGLE_VIEW_MODE:
      return state.set(VIEW_MODE, action.viewMode);
    case SET_CIC_DISPLAY_LANGUAGE:
      return state.set(CIC_DISPLAY_LANGUAGE, action.languageCode);
    default:
      return state;
  }
}

function getShowNavigationBarFromLocalStorage() {
  return ! is.existy(localStorage.getItem(SHOW_NAVIGATION_BAR)) ?
    true : JSON.parse(localStorage.getItem(SHOW_NAVIGATION_BAR));
}

function saveShowNavigationBarToLocalStorage(showNavigationBar) {
  localStorage.setItem(SHOW_NAVIGATION_BAR, showNavigationBar);
}



// WEBPACK FOOTER //
// ./data/UiState/reducer.js